module.exports = __webpack_public_path__ + "img/watage_res_14.209058d5.gif";